import React, { useState } from 'react'
import style from './cardProjectTooltip.module.scss'
import { IProject } from '../../starter/model/interfaces'
import ItemCard from '../ItemCard/ItemCard'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../starter/constants'
import TextArea from 'antd/es/input/TextArea'

export type TCardEmployeeTooltip = {
  project: IProject
}
const CardProjectTooltip = ({ project }: TCardEmployeeTooltip) => {
  const [tmpProject, setTmpProject] = useState<IProject>(project)
  const handleInputChange = (name: string, value: string): void => {
    setTmpProject({
      ...tmpProject,
      [name]: value
    })
  }
  return (
    <div className={style.wrapper}>
      <ItemCard label={'Название проекта:'} value={project.title} type={'text'} />
      <ItemCard label={'Код проекта:'} value={project.code} type={'text'} />
      <ItemCard label={'Начало проекта:'} value={dayjs(project.from).format(DATE_FORMAT)} type={'date'} />
      <ItemCard label={'Окончание проекта:'} value={dayjs(project.to).format(DATE_FORMAT)} type={'date'} />
      <ItemCard
        label={'Проектный менеджер:'}
        value={`${project.manager?.firstName} ${project.manager?.lastName}`}
        type={'text'}
      />
      <ItemCard
        label={'Ответственный сотрудник:'}
        value={`${project.responsibleEmployee?.firstName} ${project.responsibleEmployee?.lastName}`}
        type={'text'}
      />
      <span>Комментарий:</span>
      <TextArea
        rows={4}
        value={project.comment}
        name='comment'
        onChange={(e) => {
          handleInputChange('comment', e.target.value)
        }}
      />
    </div>
  )
}

export default CardProjectTooltip
